/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { HalJson } from '../../models/hal-json';
import { UserPutInput } from '../../models/user-put-input';

export interface UsersUserIdPut$Params {
  'Active-Tenant-Identifier': string;
  userId: string;
      body: UserPutInput
}

export function usersUserIdPut(http: HttpClient, rootUrl: string, params: UsersUserIdPut$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'_links'?: HalJson;
}>> {
  const rb = new RequestBuilder(rootUrl, usersUserIdPut.PATH, 'put');
  if (params) {
    rb.header('Active-Tenant-Identifier', params['Active-Tenant-Identifier'], {});
    rb.path('userId', params.userId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<{
      '_links'?: HalJson;
      }>;
    })
  );
}

usersUserIdPut.PATH = '/users/{userId}';
